// extracted by mini-css-extract-plugin
export var footer = "index-module--footer--5aHN3";
export var top = "index-module--top--XcImq";